module.exports = __webpack_public_path__ + "img/Restaurant3.a7d53aa1.png";